var angular = require('angular');
var _module = angular.module('benoit');
var _ = require('lodash');
var $ = require('jquery');

require('./_styles.scss');
require('angular-youtube-embed');
require('../../../services/lr-touch');
require('../../../services/branded-nav');

_module.requires.push(
    'youtube-embed'
);

_module.controller('LatestVideosCtrl', [
    '$log',
    '$http',
    '$element',
    '$brandedNav',

    function LatestVideosCtrl($log, $http, $element, $brandedNav) {
        $log.debug('LatestVideosCtrl', this);

        var vm = this;
        vm.model = {
            loading: false,
            videos: [],
            youtubeSettings: {
                autoplay: 1
            },
            slick: {
                numPerRow: 3,
                responsive: [ // More responseive settings are set in updateSlickSettings function
                    {
                        breakpoint: 1059
                    },
                    {
                        breakpoint: 729
                    }
                ]
            }
        };
        vm.events = {
            onBindingChanges: onBindingChanges,
            onSlideChange: onSlideChange
        };
        vm.services = {
            getNumAcross: getNumAcross
        };

        // Life Cycle Hooks
        vm.$onChanges = vm.events.onBindingChanges;

        // Functions
        function getNumAcross() {
            var width = $(window).width();

            if(width <= 679) {
                return 1;
            } else if(width <= 1059) {
                return 2;
            } else {
                return 3;
            }
        }

        function onBindingChanges(changes) {
            if(changes.youtubeUsername && changes.youtubeUsername.currentValue !== changes.youtubeUsername.previousValue) {
                fetchRSSFeed(vm.youtubeUsername);
            }
        }

        function fetchRSSFeed(username) {
            if(vm.model.loading) return;

            if(!username) return hide();

            var url = ['/v1/youtube/channels/', username, '/rss'].join('');
            vm.model.loading = true;

            $http.get(url)
            .then(function processResponse(response) {
                vm.model.videos.length = 0;
                vm.model.videos.push.apply(vm.model.videos, response.data.data.videos);

                updateSlickSettings();

                if(vm.isHidden && vm.model.videos.length){
                    show();
                } else if(!vm.model.videos.length) {
                    hide();
                }
            })
            .catch(function onError(err) {
                $log.error('LatestVideosCtrl -> fetchRSSFeed -> Error', err);
                hide();
            })
            .finally(function () {
                vm.model.loading = false;
            });
        }

        function updateSlickSettings() {
            vm.model.slick.numPerRow = Math.min(3, vm.model.videos.length);
            vm.model.slick.responsive[0].settings = {
                slidesToShow: Math.min(2, vm.model.videos.length),
                slidesToScroll: Math.min(2, vm.model.videos.length),
                slidesPerRow: Math.min(2, vm.model.videos.length)
            };
            vm.model.slick.responsive[1].settings = {
                slidesToShow: Math.min(1, vm.model.videos.length),
                slidesToScroll: Math.min(1, vm.model.videos.length),
                slidesPerRow: Math.min(1, vm.model.videos.length),
                variableWidth: false,
                dots: true
            };
        }

        function hide() {
            $brandedNav.hide('latestVideos');
            $element.css('display', 'none');
        }

        function show() {
            $brandedNav.show('latestVideos');
            $element.css('display', '');
        }

        function onSlideChange() {
            vm.model.videos.forEach(function (video) {
                video.show = false;
            });
        }
    }
]);

_module.component('latestVideos', {
    controllerAs: 'vm',
    controller: 'LatestVideosCtrl',
    template: require('./index.html'),
    bindings: {
        youtubeUsername: '@'
    }
});
